export enum FacilityTypeEnum {
  HHA = 1,
  IPPS = 2,
  Hospice = 3,
  SNF = 4,
  IRF = 5,
  Psychiatric = 6,
  ALF = 7,
  NF = 8,
  LTCH = 9,
  Other = 99
}

export const FacilityTypeOptions = [
{ id: 1, label: 'Home Health Agency (HHA)' },
{ id: 2, label: 'Short-stay acute hospital (IPPS)' },
{ id: 3, label: 'Hospice' },
{ id: 4, label: 'Skilled Nursing Facility (SNF/TCU)' },
{ id: 5, label: 'Inpatient Rehabilitation Hospital/Unit (IRF)' },
{ id: 6, label: 'Psychiatric Hospital' },
{ id: 7, label: 'Assisted Living Facility (ALF)' },
{ id: 8, label: 'Long-term nursing facility (NF)' },
{ id: 9, label: 'Long-term care hospital (LTCH)' },
{ id: 99, label: 'Other' }
];
